var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"id":"video","poster":require("@/assets/img/background.jpeg"),"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("@/assets/video/background_video.mp4"),"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }